export const commsPreferencesData = {
  commsPreferences: {
    essentialEmail: true,
    essentialPhone: true,
    essentialPost: true,
    essentialWhatsapp: true,
    nonEssentialEmail: true,
    nonEssentialPhone: true,
    nonEssentialPost: true,
    nonEssentialWhatsapp: true,
    remortgageReminders: true,
    preferenceNote: '',
    automaticallySet: true,
    mortgageMarketUpdateEmail: true,
    clientId: null,
    updatedBy: null
  },
  maskedPhone: null,
  maskedEmail: null
};
